import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getFullScreenMode } from '@app/models/personal-settings';
import { NavItem } from '@app/pcs/shared/components/sidenav/nav-item';
import { hasValue } from '@util';

@Component({
  selector: 'pcs-app-settings-menu',
  templateUrl: './app-settings-menu.component.html',
  styleUrls: ['../base-menu-dropdown.scss', './app-settings-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSettingsMenuComponent implements OnInit {
  @Input() currentUser;
  @Input() pcsDocumentationLink: string;
  @Input() mailPcsSupport: string;
  @Input() numberOfNotSeenFeatures: number;

  @Output() showFullScreen = new EventEmitter();
  @Output() logout = new EventEmitter();

  private fullScreenMode;

  ngOnInit() {
    this.fullScreenMode = getFullScreenMode(this.currentUser);
  }

  getFullScreenIcon() {
    return this.fullScreenMode ? 'fullscreen_exit' : 'fullscreen';
  }

  toggleFullScreen() {
    this.fullScreenMode = !this.fullScreenMode;
    this.showFullScreen.emit();
  }

  notSeenFeaturesLink() {
    return {
      path: ['features'],
      icon: 'lightbulb_outline',
      iconSize: 'iconM',
      badge: hasValue(this.numberOfNotSeenFeatures) && this.numberOfNotSeenFeatures !== 0
        ? this.numberOfNotSeenFeatures.toString() : null
    } as NavItem;
  }
}
